import { API_AUTH } from "./common";

const TaiSanCongTyApi = {
  PhanQuyen: () =>
    API_AUTH.get(`quan-ly-tai-san/phan-quyen-tai-san-cong-ty`, {}),
  DanhSach: (maTaiSan, kho, soSanh, giaTriTimKiem, pageIndex, pageSize) =>
    API_AUTH.get(
      `quan-ly-tai-san/danh-sach-tai-san-cong-ty?maTaiSan=${maTaiSan}&kho=${kho}&soSanh=${soSanh}&giaTriTimKiem=${giaTriTimKiem}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
    ),
};

export default TaiSanCongTyApi;
